import { render, staticRenderFns } from "./dropMatching.vue?vue&type=template&id=501f080b&scoped=true&"
import script from "./dropMatching.vue?vue&type=script&lang=js&"
export * from "./dropMatching.vue?vue&type=script&lang=js&"
import style0 from "./dropMatching.vue?vue&type=style&index=0&id=501f080b&lang=less&scoped=true&"
import style1 from "./dropMatching.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f080b",
  null
  
)

export default component.exports